import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';

import { FetchData } from './utils/DataFetch';
import { GetCookie } from './utils/Common';

import Logo from '../images/logo1.png';

export class WorkOrderIntNoLongerAssigned extends Component {
  static displayName = WorkOrderIntNoLongerAssigned.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));

    this.state = {
      display_message: '',
    };
  }

  componentDidMount() {
    // Add event listener for ESC key to close modal
    document.addEventListener('keydown', this.handleEscKey, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleEscKey, false);
  }

  handleEscKey = (event) => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      if (this.props.modal && typeof this.props.setModal === 'function') {
        this.props.setModal();
      }
    }
  };

  render() {
    return (
      <div>
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.setModal}
          style={{ height: '500px', width: '400px' }}
        >
          <ModalHeader style={{ justifyContent: 'center', display: 'flex' }}>
            You are not assigned to this job.
          </ModalHeader>
          <ModalBody>
            <div
              style={{
                fontSize: '1.2em',
                textAlign: 'center',
                marginTop: '10px',
                lineHeight: 1.8,
              }}
            >
              <div>If you feel this is in error</div>
              <div>
                Please call <b>800-522-2320</b>
              </div>
              <div>to speak to one of our schedulers.</div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
